import React from 'react';
import { CustomerFeedback } from '@gjensidige/gpf-feedback';
import { hot } from 'react-hot-loader/root';
import { App } from './App';
import { GlobalStateProvider } from './context/GlobalContext';
import { TrackingProvider } from '@gjensidige/core-analytics/lib/tracking-context';
import { LOGGER_ENDPOINT } from './utils/api';
import { remoteLogError } from '@gjensidige/gpf-js-utils/es6/logging/error-handler';
import { tracker } from './tracking';
import { createFeatureFlagsContext } from '@gjensidige/gpf-react-components';
const AppWrapper = () => (React.createElement(GlobalStateProvider, null,
    React.createElement(TrackingProvider, { options: tracker.options },
        React.createElement(App, null)),
    React.createElement(CustomerFeedback, { client: { id: 'gpf-fkl' }, metadata: [] })));
// TODO: Fjern etter IDD er prodsatt for alle
export const FeatureFlagsContext = createFeatureFlagsContext();
window.onerror = (event, source, fileno, columnNumber, error) => {
    void remoteLogError(LOGGER_ENDPOINT, error);
};
export default hot(AppWrapper);
